import { numFormatter } from "../../../helpers/utils";
import styled from "styled-components";
import { useContext } from "react";
import { WidgetContext } from "../../widgetContext";

const SmallNumberCostWidget = () => {
  const widget = useContext(WidgetContext);

  const handleWidgetOnClick = () => {
    if (widget.widgetOnClick) {
      widget.widgetOnClick();
    }
  };

  return (
    <Wrapper onClick={handleWidgetOnClick}>
      <div className="widget-content">
        <span className="title">{widget.widgetData?.data?.currency}</span>
        <span
          className="value"
          data-toggle="tooltip"
          data-placement="top"
          title={widget.widgetData?.data?.value}
        >
          {numFormatter(widget.widgetData?.data?.value)}
        </span>
        <span className="description">{widget.widgetData?.data?.description}</span>
      </div>
    </Wrapper>
  );
};

export default SmallNumberCostWidget;

const Wrapper = styled.div`
  border-radius: 20px;
  background-color: ${({ theme }) => theme.widget.background};
  filter: drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.05));
  width: 100%;
  height: 100%;
  padding: 25px;
  display: flex;
  cursor: pointer;
  justify-content: center;

  .widget-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: 10px;

    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 2px;
    }
    .value {
      display: block;
      font-size: 4.5rem;
      line-height: 1.1;
      font-weight: 700;
      letter-spacing: -2px;
      margin-bottom: 8px;
    }
    .description {
      display: block;
      font-size: 22px;
      font-weight: 500;
      line-height: 1.3;
      opacity: 0.8;
    }
  }

  @media (max-width: 995px) {
    padding: 20px;
    .widget-content {
      .title {
        font-size: 14px;
      }
      .value {
        font-size: 3rem;
      }
      .description {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 767px) {
    padding: 16px;
    border-radius: 16px;
    .widget-content {
      padding: 6px;
      .title {
        font-size: 11px;
      }
      .value {
        font-size: 2rem;
        letter-spacing: -1px;
        margin-bottom: 4px;
      }
      .description {
        font-size: 14px;
      }
    }
  }
`;
